import React from 'react';
import { landingPlayNowButtonStyles } from './LandingPlayNowButton.styles';

interface LandingPlayNowButtonProps {
  handlePlayNowClick: () => void;
}

export const LandingPlayNowButton: React.FC<LandingPlayNowButtonProps> = ({
  handlePlayNowClick,
}) => {
  return (
    <div className="landing--play-btn xs-shrink-0 w-100 flex-col hidden xs-flex xs-justify-center  xs-mx-auto">
      <div
        className="btn btn--xl btn--primary sm-btn xs-btn--lg w-100"
        style={landingPlayNowButtonStyles.playNowButton}
        onClick={() => handlePlayNowClick()}
      >
        PLAY NOW
      </div>
    </div>
  );
};